import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn, Typography } from '@prenuvo/halo';

import { PreferenceRadioOption } from './preferences.model';

interface PreferenceRadioButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'onChange'> {
  isFirst: boolean;
  isLast: boolean;
  isSelected: boolean;
  onChange: (value: string) => void;
  option: PreferenceRadioOption;
}

export const PreferenceRadioButton = forwardRef<HTMLButtonElement, PreferenceRadioButtonProps>(
  function PreferenceRadioButton(
    { className, isFirst, isLast, isSelected, onChange, option, ...rest },
    ref,
  ) {
    return (
      <button
        {...rest}
        aria-checked={isSelected}
        className={cn(
          'relative -ml-px h-8 w-20 border border-neutral-600 px-3 py-0',
          'dark:bg-fct-root dark:text-neutral-50',
          'dark:hover:z-10 dark:hover:border-blue-500 dark:hover:bg-blue-500/10',
          'dark:focus-visible:z-10 dark:focus-visible:ring-1 dark:focus-visible:ring-blue-500 dark:focus-visible:outline-none',
          {
            'dark:z-10 dark:border-blue-500 dark:bg-blue-500/10': isSelected,
            'ml-0 rounded-l-full': isFirst,
            'rounded-r-full': isLast,
          },
          className,
        )}
        onClick={() => onChange(option.value)}
        ref={ref}
        role="radio"
        type="button"
      >
        <Typography translationKey={option.label} variant="paragraph-sm" />
      </button>
    );
  },
);
